<nb-card class="price-history-dialog" style="min-width: 560px; max-width: 760px; max-height: 80vh;">
  <nb-card-header class="d-flex justify-content-between align-items-center">
    <div>
      <h5 class="mb-0">Price History</h5>
      <small *ngIf="productName" class="text-muted">for {{ productName }}</small>
    </div>
    <button class="btn btn-ghost-danger btn-sm" type="button" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body style="overflow-y: auto;">
    <div *ngIf="loading" class="text-center py-4">
      <nb-spinner size="medium"></nb-spinner>
      <p class="text-muted mt-2 mb-0">Loading price history…</p>
    </div>

    <div *ngIf="!loading && schedules.length === 0" class="text-center py-4 text-muted">
      <nb-icon icon="pricetags-outline" style="font-size: 2rem;"></nb-icon>
      <p class="mt-2 mb-0">No price schedule history recorded yet.</p>
    </div>

    <div *ngIf="!loading && schedules.length > 0" class="price-history-list">
      <div class="price-history-item" *ngFor="let schedule of schedules">
        <div class="d-flex justify-content-between align-items-start gap-3">
          <div class="flex-grow-1">
            <div class="price-summary">{{ formatPrice(schedule.price) }}</div>
            <div class="text-muted small" *ngIf="schedule.previousPrice != null">
              was {{ formatPrice(schedule.previousPrice) }}
            </div>
            <div class="price-meta text-muted small mt-1">
              <span>Activates: {{ formatDate(schedule.activatesAt) }}</span>
              <span class="ms-2">Ends: {{ formatDate(schedule.deactivatesAt) }}</span>
              <span *ngIf="schedule.activatedAt" class="ms-2">Activated: {{ formatDate(schedule.activatedAt) }}</span>
              <span *ngIf="schedule.deactivatedAt" class="ms-2">Deactivated: {{ formatDate(schedule.deactivatedAt) }}</span>
            </div>

            <div *ngIf="schedule.status === 'active' && editingActiveEndId === schedule._id" class="active-end-edit mt-2">
              <label class="form-label small mb-1">Ends at</label>
              <input type="datetime-local" class="form-control form-control-sm" [(ngModel)]="editActiveDeactivatesAt">
              <div class="text-danger small" *ngIf="editActiveEndError">{{ editActiveEndError }}</div>
              <div class="d-flex flex-wrap gap-2 mt-2">
                <button type="button" class="btn btn-sm btn-primary"
                  [disabled]="savingScheduleId === schedule._id"
                  (click)="saveActiveEnd(schedule)">Save end</button>
                <button type="button" class="btn btn-sm btn-outline-secondary"
                  [disabled]="savingScheduleId === schedule._id"
                  (click)="cancelEditActiveEnd()">Cancel</button>
                <button type="button" class="btn btn-sm btn-outline-danger"
                  *ngIf="schedule.deactivatesAt"
                  [disabled]="savingScheduleId === schedule._id"
                  (click)="clearActiveEnd(schedule)">Clear end</button>
              </div>
            </div>
          </div>
          <div class="text-end">
            <span class="badge" [ngClass]="getStatusInfo(schedule.status).badgeClass">
              {{ getStatusInfo(schedule.status).label }}
            </span>
            <div class="text-muted small mt-1">Created: {{ formatDate(schedule.createdAt) }}</div>
            <button *ngIf="schedule.status === 'active' && editingActiveEndId !== schedule._id"
              type="button" class="btn btn-sm btn-outline-primary mt-2"
              (click)="startEditActiveEnd(schedule)">
              Set end
            </button>
          </div>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer class="d-flex justify-content-end">
    <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
  </nb-card-footer>
</nb-card>
